import type { ReactNode } from 'react';
import { IconButton } from '../Button';
import type { ToggleProps } from '../Form';
import { FormControlSizes } from '../Form/types';
import { IconName } from '../Icons';
import { Popover } from '../Popover/Popover';
import type { PopoverState } from '../Popover/types';
import { usePopoverState } from '../Popover/usePopoverState';
import { BlotterMenuWrapper } from './styles';

interface BlotterTableExtrasMenuProps extends PopoverState {
  children: ReactNode;
  dataTestID?: string;
}

/** Common tooltip placement for Extras Menu controls
 * so that the tooltip doesn't hover over other items
 * (for now in toggle, but expand as needed for other controls) */
export const EXTRAS_MENU_TOOLTIP_PROPS: ToggleProps['tooltipProps'] = {
  placement: 'left',
};
/**
 * The BlotterTableExtrasMenu gives you the kebab menu and a popover within which you can render your Toggles, buttons, and similar.
 */
export function BlotterTableExtrasMenu({
  children,
  dataTestID = 'blotter-table-extras-menu',
  ...popover
}: BlotterTableExtrasMenuProps) {
  return (
    <Popover {...popover}>
      <IconButton ghost icon={IconName.DotsVertical} size={FormControlSizes.Small} data-testid={dataTestID} />
      <BlotterMenuWrapper data-testid="blotter-table-extras-menu-content">{children}</BlotterMenuWrapper>
    </Popover>
  );
}

export function useBlotterTableExtrasMenu() {
  return usePopoverState({
    closeOnClickOutside: true,
    trigger: 'click',
    placement: 'bottom-end',
    usePortal: true,
  });
}
